import { render, staticRenderFns } from "./DashboardFinancialStatistics.vue?vue&type=template&id=abacb942&scoped=true&"
import script from "./DashboardFinancialStatistics.vue?vue&type=script&lang=js&"
export * from "./DashboardFinancialStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFinancialStatistics.vue?vue&type=style&index=0&id=abacb942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abacb942",
  null
  
)

export default component.exports